module.exports = __webpack_public_path__ + "assets/1aee9bf0daac86e8f46ea85020ea5a89.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/slides/4.png
// module id = 384
// module chunks = 1